"use strict";

var _variants = require("./variants");
//# sourceMappingURL=settingsDefinition.js.map